export default __webpack_public_path__ + "static/media/GothamSSm-ExtraLight.ccd28f07.eot";